<template>
	<div class="sa-list-component">
		<div class="sa-list-component-header">
			<div class="sa-page-search-component">
				<b-form style="width: 100%" @submit.prevent="onSubmit">
					<b-row class="sa-form-btn-filter">
						<b-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
							<div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
								<label class="sa-label-data">Magazzino\Armadietto</label>
								<select class="sa-prescrizione-input" v-model="filtroArticoli.magazzinoCodice"
									@change="onchangeMagazzino" :disabled="filtroMagazzinoDisabled">
									<option :value="null">Tutti</option>
									<option v-for="item in magazzinoMagazziniOptions" :key="item.id"
										:value="item.codiceMagazzino">{{ item.descrizioneMagazzino }}</option>
								</select>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
							<label class="sa-label-data">Articolo</label>
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroArticoli.codiceArticolo"
									placeholder="Codice Articolo..." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="5" xl="6">
							<label class="sa-label-data">Articolo</label>
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroArticoli.descrizione"
									placeholder="Nome Articolo..." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<!-- <b-col class="sa-padding-right text-right">
							<b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
							<b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
						</b-col> -->
					</b-row>
				</b-form>
			</div>
		</div>
		<div class="sa-list-component-body">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
			<div class="b-table-sticky-header">
				<b-table :busy="isBusy" sticky-header ref="table" stacked="lg" striped hover :items="storicoItems"
					:fields="fieldsColumn" :current-page="currentPage" :per-page="perPage" sort-icon-left
					head-variant="light" class="sa-b-table" selectable select-mode="single"
					@row-selected="onRowSelectedFarmaco">
					<template #table-busy>
						<div class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong style="padding-left: 10px">Caricamento dati in corso...</strong>
						</div>
					</template>
					<template #cell(index)="row">
						<span> {{ (page - 1) * perPage + row.index + 1 }} </span>
					</template>
					<template #cell(articolo)="row">
						<span
							style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
								row.item.descrizione }}</span>
						<span v-if="row.item.codiceTipoArticolo === 'FRM'"
							style="font-weight: 400; display: flex; width: 100%; justify-content: start; align-items: center">{{
								row.item.codiceAic }} </span>
						<span v-else
							style="font-weight: 400; display: flex; width: 100%; justify-content: start; align-items: center">{{
								row.item.codiceArticolo }} </span>
					</template>
					<template #cell(quantitaConfezione)="row">
						<span
							style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
								row.item.ripartizioneFormato }} {{ row.item.descrizioneMultiplo }}</span>
					</template>
					<template #cell(quantitaBase)="row">
						<span
							style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
								row.item.quantitaBase }} {{ row.item.unitaBase }}</span>
					</template>
					<template #cell(dataOraScadenza)="row">
						<span
							style="font-weight: 600; display: flex; width: 100%; justify-content: start; align-items: center">{{
								formatDateTime(row.item.dataOraScadenza) }}</span>
					</template>
				</b-table>
			</div>
			<!-- <div v-else class="text-center sa-page-body-nodata">
                <i class="far fa-plus-square fa-3x text-muted mb-3"></i>
                <p>Nessuno armadietto configurato per l'ospite</p>
            </div> -->
		</div>
		<div class="sa-list-component-footer">
			<b-modal ref="mdlStampaReferto" size="xl" style="height: 100%">
				<b-embed type="iframe" :src="stampaReport" allowfullscreen></b-embed>
			</b-modal>
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
		<div class="sa-flexbox-footer">
			<div class="sa-flexbox-footer-bar">
				<div class="sa-flexbox-footer-bar-separator"></div>
				<div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-danger"
						@click="onClickChiudi()">Annulla Selezione</b-button></div>
				<div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-success"
						@click="onClickConferma()" :disabled="isBusy">Conferma Selezione</b-button></div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
// import DateFilterComponent from "../../utility/components/DateFilterComponent.vue";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";
import moment from "moment";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
export default {
	name: "MagazzinoArticoliTabStoricoContabileComponent",
	mixins: [UtilityMixin, MagazzinoMixins],
	components: {},
	props: {
		visibleColumns: {
			type: Array,
			required: false,
			default: () => {
				return null;
			},
		},
	},
	data() {
		return {
			currentPage: 1,
			page: 1,
			perPage: 50,
			filtroMagazzinoDisabled: false,
			filtroArticoli: { codiceStruttura: null, magazzinoCodice: null, codiceArticolo: null, descrizione: null },
			strutturaOptions: [],
			pathResource: "/contabilitadocumenti",
			pathResourceStampa: "/print/createreport",
			reportName: "documenti",
			farmacoSelezionato: null,
			stampaReport: null,
			rows: 0,
			fieldStorico: [
				{
					label: "*",
					key: "index",
					thStyle: "width: 0.5rem",
				},
				{
					label: "Magazzino",
					key: "magazzinoDescrizione",
					sortable: true,
				},
				{
					label: "Cod. Articolo",
					key: "articolo",
					sortable: true,
				},
				{
					label: "Cod. Conf.",
					key: "codiceConfezione",
					sortable: true,
				},
				{
					label: "Qnt. Conf.",
					key: "quantitaConfezione",
					sortable: true,
				},
				{
					label: "Qnt. Base.",
					key: "quantitaBase",
					sortable: true,
				},
				{
					label: "Data Scadenza",
					key: "dataOraScadenza",
					sortable: true,
				},
			],
			jsonData: {},
			filter: {},
			storicoItems: [],
			listkey: 0,
			pathResouce: "/articolimagazzini/magazzino",
		};
	},
	computed: {
		fieldsColumn() {
			let me = this;
			let columns = [];
			if (!this.visibleColumns) {
				columns = this.fieldStorico;
			} else {
				columns = me.fieldStorico.filter((value) => this.visibleColumns.includes(value.key));
			}
			return columns;
		},
		armadietto() {
			// console.log(this.magazzinoMagazziniOptions);

			if (this.magazzinoMagazziniOptions.length > 0) {
				return this.magazzinoMagazziniOptions.find((e) => {
					e.codiceMagazzino === this.filtroArticoli.magazzinoCodice;
				});
			}
			// console.log(this.magazzinoMagazziniOptions);

			return this.magazzinoMagazziniOptions;
		},
	},

	mounted() { },
	methods: {
		init(filtro, filtroMagazzinoDisabled = false) {
			this.filtroMagazzinoDisabled = filtroMagazzinoDisabled;
			if (filtro) {
				this.filtroArticoli = filtro;
			}
			this.magazzinoMagazziniLoadData({ codiceStruttura: filtro?.codiceStruttura });
			this.loadStoricoGiacenzaArticolo();
		},
		loadStoricoGiacenzaArticolo() {
			let me = this;
			this.isBusy = true;
			UtilityMixin.methods.loadDataResources(me.pathResouce, this.filtroArticoli, me.loadStoricoGiacenzaArticoloSuccess, me.loadStoricoGiacenzaArticoloError);
		},
		loadStoricoGiacenzaArticoloSuccess(response) {
			let me = this;
			me.rows = response.data.data.list.length;
			me.storicoItems = response.data.data.list;
			me.listkey++;
			//console.log(me.storicoItems);

			this.isBusy = false;
		},
		loadStoricoGiacenzaArticoloError(error) {
			console.log(error);
			this.isBusy = false;
		},
		getStyleOperazioneMagazzino(value) {
			return { color: value > 0 ? "green" : "red" };
		},
		getData(value) {
			return moment(new Date(value)).format("DD/MM/YYYY");
		},
		getDescrizioneOperazioneMagazzino(value) {
			return value > 0 ? "CARICO" : "SCARICO";
		},
		onSubmit() {
			// console.log("Passa da qua");
			// let dateFilter = this.$refs.cmpDateFilterComponent.getFilter();
			// this.filtro.dataDal = dateFilter.dataDal;
			// this.filtro.dataAl = dateFilter.dataAl;
			this.loadStoricoGiacenzaArticolo();
		},
		onClickModalOpenPdf(row) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + row.item.idDocumento;
			axios.get(link).then((response) => {
				let printData = response.data.data;
				let linkReport = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
				axios.post(linkReport, { reportName: me.reportName, data: printData }).then((response) => {
					me.$refs.mdlStampaReferto.show();
					me.stampaReport = "data:application/pdf;base64," + response.data.base64;
				});
			});
		},
		onClickVisualizzaDocumento(row) {
			let pathDocumentoFe = "/contabilita/documenti/view/";
			this.$router.push(pathDocumentoFe + row.item.idDocumento);
		},
		onReset() { },
		onRowSelectedFarmaco(item) {
			let me = this;
			// console.log(item);
			if (item.length > 0) {
				me.farmacoSelezionato = item[0];
			}
		},
		onClickChiudi() {
			this.$emit("annullaSelezione");
		},
		onClickConferma() {
			let prescrizioneFarmaco = {
				codiceProdotto: this.farmacoSelezionato.codiceArticolo,
				atcGmp: this.farmacoSelezionato.codiceAic,
				descrizione: this.farmacoSelezionato.descrizione,
				unitaMisura: "Pz",
				quantita: 1,
				costo: 0,
				formaFarmaceutica: { descrizione: this.farmacoSelezionato.unitaBase },
			};
			this.$emit("confermaSelezione", prescrizioneFarmaco);
		},
		onchangeMagazzino() {
			this.onSubmit();
		},
	},
};
</script>
